export enum AzureCertificateValidVersions {
  'VitoconnectOptolink' = '2.8.0',
  'VitoconnectOpenTherm' = '1.4.8',
  'VitoconnectOPTO2' = '2.48.9',
  'SA1800019WiFi' = '506.2244.0004',
  'WiFi_SA0041' = '504.2244.0048',
  'TCU101' = '504.2222.0043',
  'TCU102' = '503.2238.0015',
}
